import { InputField } from "@typings/InputField";
import { LicensorInput } from "@typings/Licensor";
import { Partner } from "@typings/Partner";

class InputFields {
  ROLE_DESCRIPTION = `The following licence manager roles are available:<br /><br />
      <b>partner</b>: Can create and manage licence managers and licences<br />
      <b>licensor</b>: Cannot create or manage licence managers, but can create and manage licences<br />`;

  ROLE_DESCRIPTION_ADMIN = `The following licence manager roles are available:<br /><br />
      <b>admin</b>: Can create and manage licence managers, licences and partners<br />
      <b>admin_licensor</b>: Currently the same as 'admin'<br />`;

  FIELDS: InputField[] = [
    {
      name: "name",
      type: "string",
      label: "Name",
      required: true,
    },
    {
      name: "email",
      type: "string",
      label: "Email",
      required: true,
      validate: (field: InputField) =>
        /^\S.*@.*\..*\S$/.test(field.value || "") || "Incorrect email format",
    },
    {
      name: "role_name",
      type: "string",
      label: "Role",
      description: this.ROLE_DESCRIPTION,
      enum: [],
      noItemsMessage: "Loading roles...",
      noSelectionMessage: "Select a role",
      required: true,
    },
    {
      name: "description",
      type: "string",
      label: "Description",
    },
  ];

  buildData(fields: InputField[], partner?: Partner): LicensorInput {
    const getValue = (name: string): any => {
      const field = fields.find(f => f.name === name);
      return field && field.value;
    };
    return {
      name: getValue("name"),
      email: getValue("email"),
      description: getValue("description"),
      role_name: getValue("role_name"),
      partner_id: partner?.id || null,
    };
  }
}

export default new InputFields();
